import React from 'react';
import PropTypes from 'prop-types';
import { Marker, getExperienceName } from '../../utils';

import { InfoContainer, InfoWrapper, InfoHeading, InfoType, InfoLocation } from './styles';

const HotelInfo = ({ hotelType, city, heading }) => (
  <InfoContainer>
    <InfoWrapper>
      <InfoType type={getExperienceName(hotelType)}>{getExperienceName(hotelType)}</InfoType>
      <InfoLocation><Marker width={15} height={20} />{city}</InfoLocation>
    </InfoWrapper>
    <InfoHeading>{heading}</InfoHeading>
  </InfoContainer>
);

HotelInfo.propTypes = {
  hotelType: PropTypes.number,
  city: PropTypes.string,
  heading: PropTypes.string,
};

export default HotelInfo;
